<template>
  <div>
    <loading :active.sync="isLoading"></loading>

    <div class="app-title">
      <div>
        <h1><i class="fas fa-list"></i> รายการบริการไอที</h1>
        <p>[{{ name }}]</p>
      </div>

      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">บริการไอทีทั้งหมด</h3>
          </div>

          <div class="tile-body">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead class="bg-light">
                  <tr>
                    <th>#</th>
                    <th>วันที่ เวลา</th>
                    <th>หน่วยงาน</th>
                    <th>รายละเอียด</th>
                    <th>ติดต่อ</th>
                    <th>สถานะ</th>
                    <th>จัดการ</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(item, index) in repairs.data"
                    :key="item.id"
                    :class="{
                      'table-warning': item.confirm_at == null,
                      'table-info': item.status_id == 4,
                      'table-success': item.completed_at != null,
                    }"
                  >
                    <td>
                      {{
                        index +
                        1 +
                        (repairs.current_page - 1) * repairs.per_page
                      }}
                    </td>

                    <td>
                      <span class="text-muted">วันที่ : </span>
                      {{ item.created_at | formatDate }}
                      <br />

                      <span class="text-muted">เวลา : </span>
                      {{ item.created_at | formatTime }}
                    </td>

                    <td>
                      <span class="text-muted">หน่วยงาน : </span>
                      {{ item.department && item.department.department_name }}

                      <br />

                      <span class="text-muted">ผู้แจ้ง : </span>
                      {{ item.end_user }}
                    </td>

                    <td>
                      <span class="text-muted">ประเภท : </span>
                      {{ item.type && item.type.type_name }}

                      <span v-if="item.ip_address">
                        <button
                          class="btn btn-link ml-2 p-0"
                          v-clipboard:copy="item.ip_address"
                          v-clipboard:success="onCopy"
                        >
                          <i class="fas fa-copy"></i> {{ item.ip_address }}
                        </button>
                      </span>

                      <br />

                      <span class="text-muted">รายละเอียด : </span>
                      {{ item.description }}

                      <br />

                      <span class="text-muted">ความเห็น : </span>

                      <span v-if="item.comment" class="text-danger">
                        {{ item.comment }}
                      </span>

                      <span v-else>-</span>
                    </td>

                    <td>
                      <span class="text-muted">มือถือ : </span>
                      <span v-if="item.mobile">{{ item.mobile }}</span>
                      <span v-else>-</span>

                      <br />

                      <span class="text-muted">ติดต่อภายใน : </span>
                      {{ item.tel }}
                    </td>

                    <td>
                      <span class="text-muted">สถานะ : </span>
                      {{ item.status && item.status.status_name }}
                      <br />

                      <span class="text-muted">ผู้รับผิดชอบ : </span>

                      <span v-if="item.user">
                        {{ item.user.name }}
                      </span>

                      <span v-else>-</span>
                    </td>

                    <td>
                      <div class="btn-group btn-group-sm">
                        <button
                          v-if="!item.confirm_at"
                          @click="confirm(item)"
                          class="btn btn-dark"
                          title="รับงาน"
                        >
                          <i class="fas fa-exclamation-triangle"></i>
                        </button>

                        <button
                          v-if="item.confirm_at && !item.completed_at"
                          @click="complete(item)"
                          :disabled="!item.user || item.user.id !== user_id"
                          class="btn btn-success"
                          title="ปิดงาน"
                        >
                          <i class="fas fa-check-circle"></i>
                        </button>

                        <button
                          @click="comment(item)"
                          :disabled="!item.confirm_at"
                          class="btn btn-info"
                        >
                          <i class="fas fa-comment"></i>
                        </button>

                        <button @click="edit(item)" class="btn btn-warning">
                          <i class="fas fa-edit"></i>
                        </button>

                        <button @click="del(item.id)" class="btn btn-danger">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <pagination
              align="right"
              :data="repairs"
              :limit="3"
              @pagination-change-page="getResults"
            />
          </div>
        </div>
      </div>
    </div>

    <repair-edit-modal
      v-if="showEdit"
      :data="editData"
      :types="types"
      :departments="departments"
      :users="users"
      :current_user_id="user_id"
      @save="saveEdit"
      @close="showEdit = false"
    />
  </div>
</template>
  
  
  
  <script>
import RepairsService from "../services/repairs.service";
import TypesService from "../services/types.service";
import DepartmentsService from "../services/departments.service";
import UsersService from "../services/users.service";
import StatusService from "../services/status.service";
import RepairEditModal from "@/components/RepairEditModal.vue";

import moment from "moment";
import { EventBus } from "@/event-bus";

export default {
  components: {
    RepairEditModal,
  },
  data() {
    return {
      showEdit: false,
      editData: {},
      repairs: {
        data: [],
        current_page: 1,
        per_page: 10,
      },

      data: {
        department_id: null,
        type_id: null,
        status_id: 1,
        user_id: null,
      },

      req: {},

      users: [],
      types: [],
      statuses: [],
      departments: [],
      opduser: [],

      user: {},

      user_id: null,
      name: this.$route.name,

      is_edit: false,
      isLoading: false,
    };
  },

  methods: {
    getUsers() {
      UsersService.getAll()
        .then((res) => {
          this.users = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onCopy() {},

    async getResults(page = 1) {
      this.isLoading = true;

      try {
        const res = await this.$http.get(`repairs?page=${page}`);

        this.repairs = res.data;
      } catch (err) {
        console.error(err);
      }

      this.isLoading = false;
    },

    confirm(item) {
      this.$swal
        .fire({
          title: "รับงาน!",
          text: "คุณต้องการรับงานนี้หรือไม่?",
          icon: "question",
          showCancelButton: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let data = { ...item };

            data.confirm_at = moment().format("YYYY-MM-DD HH:mm:ss");
            data.user_id = this.user_id;
            data.status_id = 4;

            try {
              await RepairsService.update(data.id, data);

              EventBus.$emit("my-event-name");

              this.getResults();
            } catch (e) {
              this.$swal.fire("ผิดพลาด", "ไม่สามารถอัปเดตข้อมูลได้", "error");
            }
          }
        });
    },

    complete(item) {
      this.$swal
        .fire({
          title: "เสร็จสิ้นแล้ว!",
          text: "ดำเนินการเรียบร้อยแล้ว?",
          icon: "info",
          showCancelButton: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let data = { ...item };

            data.completed_at = moment().format("YYYY-MM-DD HH:mm:ss");
            data.status_id = 3;

            try {
              await RepairsService.update(data.id, data);

              // 🔥 emit socket
              this.$socket.emit("repair-update", {
                action: "complete",
                repair_id: data.id,
              });

              EventBus.$emit("my-event-name");

              this.getResults();
            } catch (e) {
              this.$swal.fire("ผิดพลาด", "ไม่สามารถอัปเดตข้อมูลได้", "error");
            }
          }
        });
    },

    async comment(item) {
      const { value: text } = await this.$swal.fire({
        input: "textarea",
        inputLabel: "บันทึกความคิดเห็น",
        showCancelButton: true,
      });

      if (text) {
        let data = { ...item };

        data.comment = text;

        await RepairsService.update(data.id, data);

        this.getResults();
      }
    },

    edit(item) {
      this.editData = { ...item };

      this.showEdit = true;
    },
    async saveEdit(data) {
      try {
        await RepairsService.update(data.id, data);

        // 🔥 emit socket
        this.$socket.emit("repair-update", {
          action: "edit",
          repair_id: data.id,
        });

        await this.$swal.fire({
          icon: "success",
          title: "แก้ไขข้อมูลสำเร็จ",
          text: "บันทึกการแก้ไขเรียบร้อยแล้ว",
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#3085d6",
        });

        this.showEdit = false;
        this.getResults();
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถแก้ไขข้อมูลได้",
          confirmButtonText: "ปิด",
        });
      }
    },

    async insert() {
      await RepairsService.create(this.data);

      this.clear();

      this.getResults();
    },

    async update() {
      await RepairsService.update(this.data.id, this.data);

      this.clear();

      this.getResults();
    },

    clear() {
      this.data = {
        department_id: null,
        type_id: null,
        status_id: 1,
        user_id: null,
      };

      this.is_edit = false;
    },

    async remove(id) {
      await RepairsService.delete(id);

      this.getResults();
    },

    async del(id) {
      const confirm = await this.$swal.fire({
        title: "ยืนยันการลบข้อมูล",
        text: "คุณต้องการลบรายการนี้หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบเลย",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
      });

      if (confirm.isConfirmed) {
        this.remove(id);
      }
    },

    async getTypes() {
      const res = await TypesService.getAll();

      this.types = res.data;
    },

    async getDepartments() {
      const res = await DepartmentsService.getAll();

      this.departments = res.data;
    },

    async getStatus() {
      const res = await StatusService.getAll();

      this.statuses = res.data;
    },

    async getCurrentUser() {
      const res = await this.$http.get("user");

      this.user = res.data.user;
    },
  },
  mounted() {
    this.$socket.on("repair-update", (msg) => {
      console.log("Repair update received:", msg);

      // refresh list
      this.getResults();
    });
  },
  beforeDestroy() {
    this.$socket.off("repair-update");
  },
  created() {
    const u = JSON.parse(localStorage.getItem("user") || "{}");

    this.user = u;
    this.user_id = u.id;

    Promise.all([
      this.getResults(),
      this.getUsers(),
      this.getTypes(),
      this.getDepartments(),
      this.getStatus(),
    ]);
  },
};
</script>